import { RootState } from 'app/store';
import { useSelector, useDispatch } from 'react-redux';
import {
  isActivityTriggerNeeded,
  setSelectedDropDownItemAsActive
} from 'common/components/drop-downs/legacy/dropDownUtils';
import { FC, useEffect, useState } from 'react';
import { paginationPageSizeDropDownSelections } from './paginationPageSizeDropDownSelections';
import {
  nextPage,
  previousPage,
  selectPaginationOptions,
  setPageSize
} from './paginationOptionsSlice';
import { Pagination } from '../../common/components/pagination/pagination';

export const PaginationBar: FC<{ componentId: string }> = ({ componentId }) => {
  const { currentPage, pageSize, totalPages, totalRecords } = useSelector(
    (state: RootState) => selectPaginationOptions(state, componentId)
  );

  const dispatch = useDispatch();

  const [pageSizes, setPageSizes] = useState(
    paginationPageSizeDropDownSelections
  );

  const setPageSizeSelectionForDropDown = (pageSize: number): void => {
    dispatch(setPageSize({ componentId, pageSize }));
  };

  useEffect(() => {
    if (
      pageSize !== undefined &&
      isActivityTriggerNeeded(pageSizes, pageSize.toString())
    ) {
      setPageSizes(
        setSelectedDropDownItemAsActive(pageSizes, pageSize.toString())
      );
    }
  }, [pageSizes, pageSize]);

  return (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalRecords={totalRecords}
      currentPageSize={pageSize}
      pageSizes={pageSizes}
      isSticky={true}
      onPreviousPage={() => dispatch(previousPage({ componentId }))}
      onNextPage={() => dispatch(nextPage({ componentId }))}
      onPageSizeChanged={setPageSizeSelectionForDropDown}
    />
  );
};
